import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import { Link } from 'react-router-dom'


export default function ContactUs() {


  return (
    <>
      <div className="main">
        <div className='page-head'>
          <div className="container text-center">
            <nav>
              <ol className="breadcrumb mb-2 justify-content-center">
                <li className="breadcrumb-item"><a href="/">Home</a></li>
                <li className="breadcrumb-item active" aria-current="page">Contact Us</li>
              </ol>
            </nav>
            <h1>Contact Us</h1>
          </div>
        </div>

        <section className='section'>
          <div className="container">
            <h3 className='main-title'>Reach Us</h3>
            <h4 className='sub-title mb-4'>Get in touch to start discussing your cyber security needs. Not sure where to start?</h4>
            <div className="row">
              <div className="col-lg-4">
                <div className='contact-div'>
                  <h5>
                    <i className='fa fa-phone-volume me-3'></i>
                    <Link to="tel:+919879697447">+91 98796 97447</Link>
                  </h5>
                  <h5 className='mb-0'>
                    <i className='fa fa-envelope me-3'></i>
                    <Link to="mailto:omicroncorporate@gmail.com">omicroncorporate@gmail.com</Link>
                  </h5>
                </div>
                <div className='contact-div mb-0'>
                  <h5 className='mb-2'>
                    <i className='fa fa-map-marked-alt me-3'></i>
                    <span>Corporate Office</span><br />
                  </h5>
                  <h5 className='mb-3'>
                    Plot No. 2212 GIDC Phase IV,<br />
                    Wadhwan City,<br />
                    Surendranagar - 363035.
                  </h5>
                  <h5 className='mb-2'>
                    <i className='fa fa-map-marked-alt me-3'></i>
                    <span>Factory</span><br />
                  </h5>
                  <h5 className='mb-0'>
                    Plot No. 2212 GIDC Phase IV,<br />
                    Wadhwan City,<br />
                    Surendranagar - 363035.
                  </h5>
                </div>
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-7">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d942095.0360213275!2d70.54814013124995!3d22.726058200000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3959472ac2d6d0ff%3A0xc9e15e831f201477!2zT01JQ1JPTiBNQUNISU5FIFRPT0xTIPCfm6DvuI8!5e0!3m2!1sen!2sin!4v1754389335545!5m2!1sen!2sin" width="100%" height="100%" loading="lazy"></iframe>
              </div>
            </div>
          </div>
        </section>

        <section className='section bg-white'>
          <div className="container">
            <div className="row">
              <div className="col-lg-7 mx-auto">
                <h3 className='main-title text-center'>Send Inquiry</h3>
                <h4 className='sub-title text-center'>You can contact us using the form below if you have any questions about our products, services, data sheets and other general enquiries.</h4>
                <div className='inquiry-div'>
                  <div className="row">
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="form-floating mb-3">
                        <input type="text" className="form-control" id="full-name" placeholder="Full Name*" required />
                        <label>Your Full Name *</label>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="form-floating mb-3">
                        <input type="text" className="form-control" id="company-name" placeholder="Company Name" />
                        <label>Company Name</label>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="form-floating mb-3">
                        <input type="text" className="form-control" id="email" placeholder="name@example.com" required />
                        <label>Email ID *</label>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 col-12">
                      <div className="form-floating mb-3">
                        <input type="text" id="contact" className="form-control" placeholder="+91 9876543210" required />
                        <label>Contact No. *</label>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-12">
                      <div className="form-floating mb-3">
                        <input type="text" id="subject" className="form-control" placeholder='Subject' />
                        <label>Subject</label>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-12">
                      <div className="form-floating mb-3">
                        <textarea className="form-control" placeholder="Leave a comment here" style={{height:"150px"}} id="message"></textarea>
                        <label>Message *</label>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 text-center my-1">
                      <button type='submit' className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
}
